<div class="mb-3 row mt-2">
  <label class="col-sm-4 col-form-label">{{
    "DELIVERY_WEEK" | translate
  }}</label>
  <div class="col-sm-8">
    <select
      class="form-control"
      (change)="selectWeek($event)"
      [(ngModel)]="selectedWeek"
      >
      @for (weeks of monthList; track weeks; let m = $index) {
        @if (weeks.length && weeks[1].length) {
          <optgroup
            [label]="getMonthDescription(weeks[0])"
            >
            @for (week of weeks[1]; track weekValue(i, week); let i = $index) {
              <option [value]="week.value">{{ week.text }}</option>
            }
          </optgroup>
        }
      }
    </select>
  </div>
</div>
